export const VACATION_ENTRY_STATE_REQUESTED = 0;
export const VACATION_ENTRY_STATE_ACCEPTED = 1;
export const VACATION_ENTRY_STATE_DENIED = 2;
export const VACATION_ENTRY_STATE_WITHDRAWN = 3;
export const VACATION_ENTRY_REVOKE_STATE_NONE = 0;
export const VACATION_ENTRY_REVOKE_STATE_WAIT = 1;
export const VACATION_ENTRY_REVOKE_STATE_ACCEPTED = 2;
export const VACATION_ENTRY_REVOKE_STATE_DECLINED = 3;